import React, { useState } from "react";
import { useParams } from "react-router-dom";

export const ApplyForm = ({ jobTitle }) => {
  // ADD THIS LINE - get jobId from URL
  const { jobId } = useParams();
  
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: ""
  });
  const [status, setStatus] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("Submitting...");

    const payload = {
      ...formData,
      jobId
    };
    console.log("=== FORM SUBMISSION DEBUG ===");
    console.log("Payload being sent:", payload);
    console.log("jobId prop value:", jobId);
    console.log("formData:", formData);

    try {
      const response = await fetch("/api/apply", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(payload)
      });

      const responseText = await response.text();
      console.log("Response status:", response.status);
      console.log("Response body:", responseText);

      let result;
      try {
        result = JSON.parse(responseText);
      } catch {
        result = { error: "Server returned non-JSON response", details: responseText };
      }

      if (!response.ok) {
        throw new Error(result.error || result.message || `Server error: ${response.status}`);
      }

      setStatus("Application submitted successfully!");
      setFormData({ firstName: "", lastName: "", email: "", phone: "" });
    } catch (err) {
      console.error("=== ERROR ===");
      console.error("Full error:", err);
      setStatus(`Error: ${err.message}`);
    }
  };

  return (
    <div className="apply-form">
      <h1>Apply for {jobTitle}</h1>
      {/* <div style={{ background: "#f0f0f0", padding: "10px", marginBottom: "20px", fontSize: "12px" }}>
        <strong>Debug Info:</strong>
        <div>jobId prop: {jobId || "MISSING/UNDEFINED"}</div>
        <div>jobTitle prop: {jobTitle || "MISSING/UNDEFINED"}</div>
      </div> */}
      <form onSubmit={handleSubmit}>
        <label>
          First Name:
          <input
            type="text"
            name="firstName"
            value={formData.firstName}
            onChange={handleChange}
            required
          />
        </label>

        <label>
          Last Name:
          <input
            type="text"
            name="lastName"
            value={formData.lastName}
            onChange={handleChange}
            required
          />
        </label>

        <label>
          Email:
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </label>

        <label>
          Phone:
          <input
            type="tel"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            required
          />
        </label>

        <button type="submit">Submit Application</button>
      </form>
      {status && <p>{status}</p>}
    </div>
  );
};